/*
 * @Author: ningbo.kang
 * @Date: 2019-05-29 09:31:34
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2019-06-03 10:33:34
 * @Description: 用户登录-接口
 */
import db from '@/api/db';

/**
 * [model 用户管理模块]
 * @type {Object}
 */
const model = {
  /**
   * 获取用户信息
   * @param {*} param
   */
  getRoleList(param) {
    return db.post('/demo/list/tableList/getRoleList', param);
  },
  /**
   * 获取用户信息
   * @param {*} param
   */
  getServiceList(param) {
    return db.get('/demo/list/tableList/getServiceList', param);
  },

  /**
   * 获取用户信息
   * @param {*} param
   */
  getQueryList(param) {
    return db.get('/list/basic-list', param);
  },
};

export default model;
